import { render, staticRenderFns } from "./MkObjTable.vue?vue&type=template&id=75164e10&"
import script from "./MkObjTable.vue?vue&type=script&lang=js&"
export * from "./MkObjTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports